<script>
// This Modal component is originally copied from
// https://bitbucket.org/spinspire/svelte-modal/src/master/src/Modal.svelte,
// which is the code for https://www.youtube.com/watch?v=tO61qnGZer0

  let shown = false;

  export function show() {
    shown = true;
  }
  export function hide() {
    shown = false;
  }
</script>

<svelte:window
  on:keydown={e => {
    if (e.key === 'Escape') {
      hide();
    }
  }} />

{#if shown}
  <div class="modal-wrapper">
    <div class="modal">
      <span class="close" on:click={() => hide()}>&times;</span>
      <slot />
    </div>
  </div>
{/if}

<style>
  .modal-wrapper {
    background-color: rgba(0, 0, 0, 0.6);
    position: fixed;
    width: 100%;
    height: 100%;
    top: 0;
    left: 0;
  }

  .modal {
    resize: both;
    overflow: auto;
    background-color: white;
    padding: 1rem;
    min-width: 20em;
    max-width: 80%;
    position: absolute;
    top: 50%;
    left: 50%;
    transform: translate(-50%, -50%);
    border-radius: 4px;

  }
  .close {
    float: right;
    cursor: pointer;
  }
  .close:hover {
    font-weight: bold;
  }
</style>
